import { observer } from "mobx-react-lite";
import { ModalStore } from "@root/stores/modalStore";
import { ArrowBack, Close } from "@mui/icons-material";
import { Box, Dialog, DialogContent, IconButton, Typography } from "@mui/material";
import { OrganizationView } from "@root/pages/index/components/OrganizationView";
import { Event, Organization } from "@root/utils/entities";
import { APP_MODAL_MAX_WIDTH } from "./modalConstants";

type ViewOrganizationModalProps = {
  store: ModalStore;
  organization?: Organization;
  onClose: () => void;
  onViewEvent: (event: Event) => void;
  onBack?: () => void;
};

export const ViewOrganizationModal = observer(
  ({
    store,
    organization,
    onClose,
    onViewEvent,
    onBack,
  }: ViewOrganizationModalProps) => {
    if (!organization) return;

    return (
      <Dialog
        open={store.isOpen}
        onClose={() => onClose()}
        fullWidth={true}
        disableScrollLock={true}
        PaperProps={{
          sx: {
            borderRadius: "1rem",
            boxShadow: "rgba(0, 0, 0, 0.16) 0px 4px 16px",
            maxWidth: APP_MODAL_MAX_WIDTH,
            width: "100%",
          },
        }}
      >
        <DialogContent
          sx={(theme) => ({
            backgroundColor: theme.palette.background.paper,
            padding: 0,
          })}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
              height: 56,
              borderBottom: "1px solid #E0E0E0",
              backgroundColor: "#fff",
            }}
          >
            {onBack && (
              <IconButton
                onClick={onBack}
                sx={{
                  position: "absolute",
                  left: 12,
                  top: "50%",
                  transform: "translateY(-50%)",
                  width: 36,
                  height: 36,
                  color: "#000",
                  "&:hover": {
                    background: "rgba(0, 0, 0, 0.05)",
                  },
                }}
                aria-label="Back to event details"
              >
                <ArrowBack sx={{ fontSize: "1.25rem" }} />
              </IconButton>
            )}
            <Typography
              sx={{
                fontSize: "1.125rem",
                fontWeight: 600,
                color: "#000",
              }}
            >
              Organization Profile
            </Typography>
            <IconButton
              onClick={() => onClose()}
              sx={{
                position: "absolute",
                right: 12,
                top: "50%",
                transform: "translateY(-50%)",
                width: 36,
                height: 36,
                color: "#000",
                "&:hover": {
                  background: "rgba(0, 0, 0, 0.05)",
                },
              }}
              aria-label="Close organization profile"
            >
              <Close sx={{ fontSize: "1.25rem" }} />
            </IconButton>
          </Box>
          <OrganizationView
            organization={organization}
            onViewEvent={(event) => onViewEvent(event)}
          />
        </DialogContent>
      </Dialog>
    );
  }
);
